import {
  ContentNotFound,
  Layout,
  SearchResultsCollection,
  SearchResultsHeader,
} from '@common'
import { IPageMetaDataSearchPage, ISearchResultsScreen } from '@interfaces'
import SEARCH_FILTER_FACETS, {
  AVALIABLE_SEARCH_FACETS,
} from '@lib/const/search-filter-facets.const'
import { useRouterLoading } from '@lib/hooks'
import { SearchService } from '@services'
import { useStore } from '@store'
import { observer } from 'mobx-react-lite'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const SearchResultsScreen = observer(
  ({ metaData, pageData, global: { navigation } }: ISearchResultsScreen) => {
    const { t } = useTranslation()
    const router = useRouter()
    const {
      search: { setMetaData },
    } = useStore()

    // side effects
    const { isLoading } = useRouterLoading(false)

    useEffect(() => {
      if (!pageData.error) {
        setMetaData(metaData)
      }
    }, [metaData, setMetaData, pageData])

    if (pageData.error) {
      return (
        <Layout
          title={t('common:ssmPageTitle')}
          navigation={navigation}
          path={router.asPath}
        >
          <ContentNotFound infoType="serverSideError" />
        </Layout>
      )
    }

    return (
      <Layout
        title={t('search:pageTitle')}
        navigation={navigation}
        path={router.asPath}
      >
        <SearchResultsHeader filterFacets={SEARCH_FILTER_FACETS} />
        <SearchResultsCollection
          metaData={metaData}
          results={pageData.data?.results}
          isLoading={isLoading}
        />
      </Layout>
    )
  }
)

export default SearchResultsScreen

interface ISSR {
  locale: string
  query: IPageMetaDataSearchPage
}

export async function getServerSideProps({ locale, query }: ISSR) {
  const searchTerm = query?.searchTerm || ''
  const searchFacet = query?.searchFacet || 'all'
  const page = query?.page || '1'
  const totalPage = '1'
  const totalCount = '0'

  const metaData = {
    searchTerm,
    searchFacet,
    page,
    totalPage,
    totalCount,
  }

  const pageData = {
    data: {
      results: null,
    },
    error: null,
  }

  // check safe facet type
  const isSafeType = AVALIABLE_SEARCH_FACETS.some((o) => o === searchFacet)

  if (!isSafeType) {
    pageData.error = 'Not valid search facet type.'
    return {
      props: { pageData, metaData },
    }
  }

  try {
    const response = await SearchService.getSearchResults(
      locale,
      searchTerm,
      parseInt(page, 10) - 1,
      searchFacet
    )

    if (response) {
      pageData.data.results = response?.results || null

      metaData.totalCount = response?.metaData?.totalCount || '0'
      metaData.totalPage = response?.metaData?.totalPage || '1'
    }
  } catch (err) {
    if (err instanceof Error) {
      pageData.error = { message: err.message }
    }
  }

  return {
    props: { pageData, metaData },
  }
}
